import {
    FETCH_PAYMENT_LINK_REQUEST,
    FETCH_PAYMENT_LINK_SUCCESS,
    FETCH_PAYMENT_LINK_ERROR,
    HIDE_PAYMENT_LINK_LOADER,
    SHOW_PAYMENT_LINK_LOADER,
    FETCH_TRANSACTION_PAYMENT_REQUEST,
    FETCH_TRANSACTION_PAYMENT_SUCCESS,
    FETCH_TRANSACTION_PAYMENT_ERROR,
    CREATE_PAY_LINK_REQUEST,
    CREATE_PAY_LINK_SUCCESS,
    CREATE_PAY_LINK_ERROR,
    UPDATE_PAY_LINK_REQUEST,
    UPDATE_PAY_LINK_SUCCESS,
    UPDATE_PAY_LINK_ERROR,
    SHARE_PAY_LINK_REQUEST,
    SHARE_PAY_LINK_SUCCESS,
    SHARE_PAY_LINK_ERROR,
    VIEW_PAY_LINK_REQUEST,
    VIEW_PAY_LINK_SUCCESS,
    VIEW_PAY_LINK_ERROR,
    RE_SHARE_PAY_LINK_REQUEST,
    RE_SHARE_PAY_LINK_SUCCESS,
    RE_SHARE_PAY_LINK_ERROR,
    FETCH_MERCHANT_TEMPLATE_REQUEST,
    FETCH_MERCHANT_TEMPLATE_SUCCESS,
    FETCH_MERCHANT_TEMPLATE_ERROR,
    GENERATE_REPORT_ERROR,
    GENERATE_REPORT_REQUEST,
    GENERATE_REPORT_SUCCESS,
} from './paymentLink.constants';
import {
    GET_ACTIVE_REPORT_ERROR,
    GET_ACTIVE_REPORT_REQUEST,
    GET_ACTIVE_REPORT_SUCCESS,
} from '../../Transactions/redux/transactions.constants';

// Payment link table action
export const fetchPaymentLinkRequest = payload => ({
    type: FETCH_PAYMENT_LINK_REQUEST,
    payload,
});

export const fetchPaymentLinkSuccess = payload => ({
    type: FETCH_PAYMENT_LINK_SUCCESS,
    payload,
});

export const fetchPaymentLinkError = payload => ({
    type: FETCH_PAYMENT_LINK_ERROR,
    payload,
});

// Payment Link transaction view table action
export const fetchPaymentsRequest = payload => ({
    type: FETCH_TRANSACTION_PAYMENT_REQUEST,
    payload,
});

export const fetchPaymentsSuccess = payload => ({
    type: FETCH_TRANSACTION_PAYMENT_SUCCESS,
    payload,
});

export const fetchPaymentsError = payload => ({
    type: FETCH_TRANSACTION_PAYMENT_ERROR,
    payload,
});

// Create new payment link action
export const createPayLinksRequest = payload => ({
    type: CREATE_PAY_LINK_REQUEST,
    payload,
});

export const createPayLinksSuccess = payload => ({
    type: CREATE_PAY_LINK_SUCCESS,
    payload,
});

export const createPayLinksError = payload => ({
    type: CREATE_PAY_LINK_ERROR,
    payload,
});

// Share payment link via popup action
export const sharePayLinksRequest = payload => ({
    type: SHARE_PAY_LINK_REQUEST,
    payload,
});

export const sharePayLinksSuccess = payload => ({
    type: SHARE_PAY_LINK_SUCCESS,
    payload,
});

export const sharePayLinksError = payload => ({
    type: SHARE_PAY_LINK_ERROR,
    payload,
});

// Update Payment link data action.
export const updatePayLinksRequest = payload => ({
    type: UPDATE_PAY_LINK_REQUEST,
    payload,
});

export const updatePayLinksSuccess = payload => ({
    type: UPDATE_PAY_LINK_SUCCESS,
    payload,
});

export const updatePayLinksError = payload => ({
    type: UPDATE_PAY_LINK_ERROR,
    payload,
});

// View Summary action for payment link transaction view table
export const viewPayLinksRequest = payload => ({
    type: VIEW_PAY_LINK_REQUEST,
    payload,
});

export const viewPayLinksSuccess = payload => ({
    type: VIEW_PAY_LINK_SUCCESS,
    payload,
});

export const viewPayLinksError = payload => ({
    type: VIEW_PAY_LINK_ERROR,
    payload,
});

// Re share action for resend of payment link

export const reSharePayLinksRequest = payload => ({
    type: RE_SHARE_PAY_LINK_REQUEST,
    payload,
});

export const reSharePayLinksSuccess = payload => ({
    type: RE_SHARE_PAY_LINK_SUCCESS,
    payload,
});

export const reSharePayLinksError = payload => ({
    type: RE_SHARE_PAY_LINK_ERROR,
    payload,
});

// fetch merchant template actions
export const fetchMerchantTemplateRequest = payload => ({
    type: FETCH_MERCHANT_TEMPLATE_REQUEST,
    payload,
});

export const fetchMerchantTemplateSuccess = payload => ({
    type: FETCH_MERCHANT_TEMPLATE_SUCCESS,
    payload,
});

export const fetchMerchantTemplateError = payload => ({
    type: FETCH_MERCHANT_TEMPLATE_ERROR,
    payload,
});

export const generateReportRequest = payload => ({
    type: GENERATE_REPORT_REQUEST,
    payload,
});

export const generateReportSuccess = payload => ({
    type: GENERATE_REPORT_SUCCESS,
    payload,
});

export const generateReportError = payload => ({
    type: GENERATE_REPORT_ERROR,
    payload,
});

export const getActiveReportRequest = payload => ({
    type: GET_ACTIVE_REPORT_REQUEST,
    hideLoader: payload.hideLoader,
    payload,
});

export const getActiveReportSuccess = payload => ({
    type: GET_ACTIVE_REPORT_SUCCESS,
    payload,
});

export const getActiveReportError = payload => ({
    type: GET_ACTIVE_REPORT_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_PAYMENT_LINK_LOADER });

export const hideLoader = () => ({ type: HIDE_PAYMENT_LINK_LOADER });
